import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { onGetForm, onGetOne, onSave } from 'redux/actions/deaths.actions';
import {
  deathsFormSelector,
  deathsCementeriesSelector,
  deathsCivilStatesSelector,
  deathsIdCardTypesSelector,
  deathsFilesSelector,
  deathsTribesSelector,
} from 'redux/selectors/deaths.selector';

import LayoutContainer from 'containers/LayoutContainer';
import DeathsForm from 'views/public/DeathsView/components/DeathsForm';
import Loading from 'components/commons/Loading';

import { IDeathsFormData } from 'views/public/DeathsView/components/DeathsForm/types';

import 'views/public/DeathsView/components/DeathsForm/i18n';

const DeathsFormContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { id = '' } = useParams<{ id?: string }>();
  const initialValues = useTypedSelector(deathsFormSelector);
  const { loading } = useTypedSelector((state) => state.deaths);
  const cementeries = useTypedSelector(deathsCementeriesSelector);
  const civilStates = useTypedSelector(deathsCivilStatesSelector);
  const idCardTypes = useTypedSelector(deathsIdCardTypesSelector);
  const tribes = useTypedSelector(deathsTribesSelector);
  const files = useTypedSelector(deathsFilesSelector);
  const isEditing = !!id;

  useEffect(() => {
    dispatch(onGetForm());
    if (id) dispatch(onGetOne(id));
    return () => {
      dispatch(onGetOne(''));
    };
  }, [dispatch, id]);

  const onSubmit = (formData: IDeathsFormData) => dispatch(onSave(formData, id));

  return (
    <LayoutContainer isPublic title={i18next.t<string>('PUBLIC_PROCEDURES_VIEW:TITLE')}>
      <DeathsForm
        cementeries={cementeries}
        civilStates={civilStates}
        files={files}
        idCardTypes={idCardTypes}
        initialValues={initialValues}
        isEditing={isEditing}
        onSubmit={onSubmit}
        tribes={tribes}
      />
      {loading && <Loading isModalMode message={i18next.t('DEATHS_FORM:LOADING')} />}
    </LayoutContainer>
  );
};

export default DeathsFormContainer;
